import { useAccount, useMsal } from "@azure/msal-react";

export interface CurrentUser {
  oid: string;
  name: string;
  email: string;
}

export function useCurrentUser(): CurrentUser | null {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] ?? null);

  if (!account) return null;

  const claims = account.idTokenClaims as Record<string, unknown> | undefined;
  const oid = claims?.["oid"] as string | undefined;
  const name = (claims?.["name"] as string | undefined) ?? account.name ?? "";
  const email = (claims?.["preferred_username"] as string | undefined) ?? account.username ?? "";

  if (!oid) return null;
  return { oid, name, email };
}
